
export { Tabs } from "./tabs"
export { TabsContent } from "./tabs"
export { TabsList } from "./tabs"
export { TabsTrigger } from "./tabs"